import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";
import { getOrt } from "@/data/seo-orter";

// Layout för /husbil/$ort — validerar orten och låter barnrouterna
// (index + $modell) rendera sitt eget innehåll.
export const Route = createFileRoute("/husbil/$ort")({
  loader: ({ params }) => {
    const ort = getOrt(params.ort);
    if (!ort) throw notFound();
    return { ort };
  },
  component: () => <Outlet />,
});
